<template>
  <div class="news-panel">
    <news-and-update-page />
    <guidelines-page />
    <event-page />
  </div>
</template>

<script>
import NewsAndUpdatePage from '@/components/news-and-update/NewsAndUpdatePage.vue';
import GuidelinesPage from '@/components/guidelines/GuidelinesPage.vue';
import EventPage from '@/components/event/EventPage.vue'

export default {
  name: 'NewsPanel',
  components: {
    NewsAndUpdatePage,
    GuidelinesPage,
    EventPage
  }
}
</script>
<style lang="scss">
  .news-panel {
    display: grid;
    grid-template-rows: 1fr;
    gap: 16px;
  }
</style>